import { Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    referenceOrigin: 'manifest' | 'job' | 'manifestJob';
    open: boolean;
    onCancel: () => void;
    onDelete: () => Promise<void>;
};

const DeleteExternalReferenceModal = ({ referenceOrigin, open, onCancel, onDelete }: Props) => {
    const referenceEntity = referenceOrigin === 'manifest' ? 'manifest' : 'job';

    return (
        <ConfirmationModal
            width={632}
            type="error"
            title="Delete reference?"
            confirmButtonText="Delete"
            icon={<DeleteOutlined />}
            content={<Typography.Text>The reference will be removed from this {referenceEntity}</Typography.Text>}
            open={open}
            onCancel={onCancel}
            onConfirm={onDelete}
        />
    );
};

export default DeleteExternalReferenceModal;
